import { Fragment, useEffect, useState } from "react";
import Lottie from "lottie-react";
import { Link } from "react-router-dom";
import LoadingPlaceholder from "../../../../ui/loading/LoadingPlaceholder";
import FiInsightCard from "../../../../../pages/private/financial-insights/common/FiInsightCard";
import { INSIGHTS_HUB_SCHEMA } from "../../../../../utils/schemas/language/pages/insightsHubSchema";
import { getLanguageContent } from "../../../../../utils/language/languageSelector";
import BaseCarousel from "../../../../ui/carousels/common/BaseCarousel";
import FiFeatureCarouselCard from "../../../../ui/cards/finances/FiFeatureCarouselCard";
import { fetchReviewList } from "../../../../../api/reviews/PlaintrReview";
import FiReviews from "../../../../../pages/private/financial-insights/common/FiReviews";
import { FINANCIAL_INSIGHTS_LANDING_PAGE_SCHEMA } from "../../../../../utils/schemas/language/pages/financialInsightsLPSchema";
import FiReviewCard from "../../../../ui/cards/finances/FiReviewCard";

function ProductFinancialInsights({ content = {} }) {
  const [loading, setLoading] = useState(true);
  const [reviews, setReviews] = useState([]);

  const landing_content = getLanguageContent(
    FINANCIAL_INSIGHTS_LANDING_PAGE_SCHEMA,
  );

  const common_content = getLanguageContent(INSIGHTS_HUB_SCHEMA);

  useEffect(() => {
    const loadReviews = async () => {
      try {
        const response = await fetchReviewList(
          "/review/plaintr-reviews?service_type=FI&limit=20",
        );
        if (response.ok) {
          const data = await response.json();
          const formattedReviews = (data.reviews || []).map((item) => ({
            id: item.id,
            user: item.user,
            description: item.description,
            rate: item.rate,
            avatar: item.avatar,
          }));
          setReviews(formattedReviews);
        }
      } catch (error) {
        console.error("Error fetching Financial Insights reviews:", error);
      } finally {
        setLoading(false);
      }
    };

    loadReviews();
  }, []);

  return (
    <Fragment>
      <div className="product-container">
        <div className="product-left-header">
          <div className="product-icon-header">
            <Lottie
              path={`${process.env.PUBLIC_URL}/lottie/tax.json`}
              loop
              autoplay
            />
          </div>
          <div className="product-content-header">
            <h2>{content.heading}</h2>
            <p>{content.description}</p>
          </div>
        </div>
        <div className="product-right">
          <div className="product-right-section">
            <h3>{content.intro_heading}</h3>
            <div>
              {content.intro_content?.map((paragraph, index) => (
                <p key={index}>{paragraph}</p>
              ))}
            </div>
          </div>
          <div className="expert-filing-audiences product-right-section">
            <div className="fi-features-carousel-container">
              <BaseCarousel
                title={content.features_carousel.heading}
                items={common_content.tools}
                showBorder={false}
                containerClassName="fi-features-carousel"
                renderItem={(tool, index) => (
                  <FiFeatureCarouselCard
                    key={index}
                    tool={tool}
                    checkIconAlt={content.tool_card_check_icon_alt}
                  />
                )}
              />
            </div>
          </div>
          <FiInsightCard title={content?.insights_card?.title}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
                marginTop: "8px",
              }}
            >
              <p className="insight-item reset-margin">
                <span>{content?.insights_card?.description}</span>
              </p>
            </div>
          </FiInsightCard>
        </div>
        <div className="product-left">
          {(loading || reviews.length > 0) && (
            <BaseCarousel
              title={landing_content.review_section.heading}
              items={reviews}
              isLoading={loading}
              showBorder={false}
              showArrows={true}
              showDots={true}
              containerClassName="fi-review-carousel"
              GhostComponent={<LoadingPlaceholder rows={1} type="card-large" />}
              renderItem={(review) => (
                <FiReviewCard
                  key={review.id}
                  name={review.user}
                  review={review.description}
                  rate={review.rate}
                  avatar={review.avatar}
                />
              )}
            />
          )}

          <div className="tf-review-cta-container">
            <Link to="/sign-up" className="cta-button primary">
              {content.cta}
            </Link>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default ProductFinancialInsights;
